import { create } from 'zustand';
import { IResponse } from '../interfaces/common';
import { PATH } from '../config/api/path';
import apiClient from '../config/api';
import { VALIDATION_FAIL_CODE } from '../utils/constants/http';

export const useAuthStore = create<AuthContextType>(set => ({
  isAuthenticated: false,
  isCheckingAuth: true,
  userInfo: null,

  /**
   * Check if user is authenticated or not by calling the API endpoint
   * @returns {Promise<IResponse>}
   */
  checkAuth: async () => {
    // Get the current state of isCheckingAuth
    // if (get().isCheckingAuth) return null;

    const url = PATH.AUTH.CHECK_AUTH;
    set({ isCheckingAuth: true });
    try {
      const response = await apiClient.get<IResponse>(url);
      if (!response || response?.status >= VALIDATION_FAIL_CODE) {
        set({ isCheckingAuth: false, isAuthenticated: false });
        return null;
      }
      const userInfo = response.data?.data || null;
      set({
        isAuthenticated: true,
        isCheckingAuth: false,
        userInfo,
      });

      if (userInfo) {
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
      }

      return response.data;
    } catch (e: unknown) {
      console.error('Error during authentication check:', e);
      set({ isAuthenticated: false, isCheckingAuth: false });
      return null;
    }
  },

  /**
   * Set the authentication status
   * @param isAuthenticated Boolean value to set the authentication status
   */
  setAuthenticated: (isAuthenticated: boolean) => {
    set({ isAuthenticated });
  },

  /**
   * Handle login action
   * @param userInfo String value of user information
   * @returns void
   */
  login: (userInfo: LogInResponse) => {
    const parsedUserInfo = JSON.stringify(userInfo);
    set({ userInfo: userInfo, isAuthenticated: true });
    localStorage.setItem('userInfo', parsedUserInfo);
  },

  /**
   * Handle logout action
   */
  logout: () => {
    set({ userInfo: null, isAuthenticated: false });
    document.cookie = 'authToken=; Max-Age=0; path=/;';
    // Remove all localStorage
    localStorage.removeItem('userInfo');
  },
}));
